import { render, staticRenderFns } from "./DataTypeSelect.vue?vue&type=template&id=51d508a8"
import script from "./DataTypeSelect.vue?vue&type=script&lang=ts"
export * from "./DataTypeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports